import { Route } from 'vue-router';

import store from '@/store';

import { PREPACK_ROUTE_NAME } from './constant';

/**
 * 当前仓没开 Prepack 时不许停在它的任何页面上
 *
 * 按仓开关 enable_prepack_menu 原先只管菜单显隐, 路由本身照样进得去。于是在开了的仓
 * 点进任务详情、再切到没开的仓, 整页 reload 之后详情页原样重挂——页面上摆的还是上一个
 * 仓的任务。列表页因为请求里带了仓号、被后端挡住, 反倒表现正常, 两个页面口径不一致
 *
 * 拿同一个开关在路由这一层再挡一道, 菜单、地址栏与深链就是一套口径了
 *
 * **判定时开关必然已经就位**: 它由 loadDisplaySettings 写入, 而那一步在首屏那条分支里
 * 是 await 过的; 切仓走的是整页 reload, 走的正是首屏那条。默认值是 false, 万一哪天顺序
 * 变了, 表现是开了的仓也被弹回首页——看得见, 不会静默放行
 */
export const isPrepackRouteBlocked = (to: Route): boolean => {
  const name = (to.name as string) || '';

  // 前缀要连着点一起比, 只用 startsWith 会把日后叫 salesOutbound.prepackXxx 的
  // 别的功能一并拦下
  const inPrepack =
    name === PREPACK_ROUTE_NAME || name.startsWith(`${PREPACK_ROUTE_NAME}.`);

  if (!inPrepack) {
    return false;
  }

  return !(store.state as any).system.enablePrepackMenu;
};
